import React from 'react';
import { Link } from 'react-router-dom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_aureate-preview/artifacts/h6n4fhlc_Only%20Logo.png';

const NotFoundPage = () => (
  <div style={{ background: 'var(--black)', color: 'var(--ink)', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '40px 20px' }}>
    <img src={LOGO_URL} alt="" style={{ width: 80, marginBottom: 32 }} />
    <h1 style={{ fontFamily: 'var(--serif)', fontSize: 'clamp(48px, 8vw, 96px)', fontWeight: 500, lineHeight: 1, marginBottom: 16 }}>404</h1>
    <p style={{ fontFamily: 'var(--mono)', fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--mute)', marginBottom: 32 }}>
      Page not found
    </p>
    <Link
      to="/"
      className="btn btn-gold"
      data-testid="404-home-link"
    >
      Back to home
    </Link>
  </div>
);

export default NotFoundPage;
